function r(f, c, t) {
  return f.utcOffset() - c ? f.clone().utcOffset(c, t) : f;
}
export {
  r as default
};
